import { NgModule } from "@angular/core";
import { EditIngredientPage } from "./edit-ingredient";
import { CommonModule } from "@angular/common";
import { ComponentsModule } from "components/components.module";

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
  ],
  declarations: [
    EditIngredientPage,
  ],
  exports: [
    EditIngredientPage,
  ]
})
export class EditIngredientPageModule { }
